<template>
  <el-dialog
    title="分配账号"
    body-type="tip"
    width="234px"
    footer-padding="0 30px 15px"
    :visible="visible"
    class="bind-employee-box"
    :before-close="close"
  >
    <p class="info-box">店铺名称：{{ assetInfo.assetName }}</p>
    <p class="info-box mb15">店铺账号：{{ accountInfo.assetAccount }}</p>

    <div class="search-from">
      <label class="from-label">员工姓名：</label>
      <el-select
        v-model="currentSelectId"
        filterable
        remote
        clearable
        size="small"
        placeholder="请输入后搜索"
        class="w220"
        :remote-method="getAssetEmplyeeList"
        :loading="loading"
        @visible-change="handleVisibleChange"
      >
        <el-option
          v-for="item in list"
          :key="item.employeeId"
          :label="item.name"
          :value="item.employeeId"
          :disabled="item.bindable || item.status !== 2"
        >
          <span>{{ item.name }}</span>
          <span style="margin-left: 10px;">{{ item.phone }}</span>
        </el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" auto-width :clstag="`pageclick|keycount|${pageClstag}|account_op_${isReBind ? 'rebind' : 'bind'}_sure`" @click="goBind" >分配</el-button>
      <el-button plain size="small" auto-width :clstag="`pageclick|keycount|${pageClstag}|account_op_bind_${isReBind ? 'rebind' : 'bind'}_cancel`" @click="close(false)">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  assetEmployeeSet,
  assetEmplyeeList,
  assetEmployeeUnset,
} from '@/api/apis/property';

export default {
  name: 'BindEmployee',
  props: {
    visible: Boolean,
    // 资产信息
    assetInfo: {
      type: Object,
      default: () => ({}),
    },
    // 员工信息
    accountInfo: {
      type: Object,
      default: () => ({}),
    },
    isReBind: Boolean, // 是否是重新分配
    pageClstag: String, // 页面路径埋点
  },
  data() {
    return {
      list: [],
      loading: false,
      params: {},
      currentSelectId: null,
    };
  },
  computed: {
    // 已选员工信息
    currentRow() {
      let obj = {};
      if (this.currentSelectId) {
        const resList = this.list.filter((item) => item.employeeId === this.currentSelectId);
        obj = resList && resList.length !== 0 ? resList[0] : {};
      }
      return obj;
    },
  },
  created() {
    this.getAssetEmplyeeList('');
  },
  methods: {
    handleVisibleChange(visible) {
      if (!visible) {
        this.getAssetEmplyeeList('');
      }
    },
    // 获取资产列表
    async getAssetEmplyeeList(employeeName) {
      this.loading = true;
      const params = {
        assetId: this.assetInfo.assetId,
        employeeName,
      };

      const res = await assetEmplyeeList(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      this.loading = false;
      if (code === 200) {
        this.list = data.content || [];
        this.loading = false;
      } else {
        this.$message.error(message || '获取可分配员工列表失败！');
      }
    },
    // 去绑定
    goBind() {
      if (!this.currentSelectId) {
        this.$message({
          message: '请先选择要授权的员工',
          type: 'warning',
        });
        return;
      }

      // 重新绑定
      if (this.isReBind) {
        this.unbind();
      } else {
        this.bind();
      }
    },
    async unbind() {
      const params = {
        assetAccount: this.accountInfo.assetAccount,
        assetId: this.assetInfo.assetId,
        employeeId: this.accountInfo.employeeId || 1,
      };
      const res = await assetEmployeeUnset(params);
      const {
        code, message,
      } = res;
      if (code === 200) {
        this.bind();
      } else {
        this.$message.error(message || '解除授权失败无法重新授权，请稍后重试！');
      }
    },
    // 员工绑定
    async bind() {
      const params = {
        assetAccount: this.accountInfo.assetAccount,
        assetId: this.assetInfo.assetId,
        employeeId: this.currentSelectId,
      };
      const res = await assetEmployeeSet(params);
      const {
        code, message,
      } = res;
      if (code === 200) {
        this.$message({
          message: '授权成功！',
          type: 'success',
        });
        this.close(true);
      } else {
        this.$message.error(message || '授权失败请稍后重试！');
      }
    },
    // 关闭绑定
    close(update = false) {
      this.$emit('closeBind', update);
    },
  },
};
</script>

<style lang="scss" scoped>
.bind-employee-box {
  .info-box {
    margin-bottom: 22px;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 14px;
    &.mb15 {
      margin-bottom: 15px;
    }
  }
  .search-from {
    display: flex;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 30px;
    flex-wrap: wrap;
    .from-label {
      width: 60px;
    }
    .w220 {
      width: 220px;
    }
  }
}
</style>
<style lang="scss">
.bind-employee-box .el-dialog{
  min-width: 400px;
  overflow-y: scroll;
}
</style>
